<template>
  <p v-if="zonesDiffer" class="site-time-hint">
    ⓘ {{ t('common.time.siteTimeHint', { offset: siteOffsetLabel }) }}
  </p>
</template>

<script setup lang="ts">
/**
 * 「今日 / 近 7 日 / 本月」等按站点日界统计的筛选下方提示（规范 6.2）：
 * 只在设备时区与站点时区此刻不同时出现，如「ⓘ 按站点时间（UTC-3）统计」。
 */
const { t } = useI18n()
const { zonesDiffer, siteOffsetLabel } = useSiteContext()
</script>

<style scoped>
.site-time-hint {
  margin: 4px 2px 6px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--muted);
}
</style>
